export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/ce82aae38e929df8fcdd7e760ce92d73.svg";